<template>
  <div class="listContainer">
    <!-- content -->
    <!-- 下载合同 -->
    <section>
      <div>
        <label><i>*</i>工作状态：</label>
        <a-radio-group v-model="on_job">
          <a-radio :value="0">
            全部
          </a-radio>
          <a-radio :value="1">
            在职
          </a-radio>
          <a-radio :value="2">
            离职
          </a-radio>
        </a-radio-group>
      </div>
      <div>
        <label>入职日期：</label>
        <a-range-picker
          :ranges="{
            今天: [moment(), moment()],
            本月: [moment().startOf('month'), moment()],
            上月: [
              moment()
                .month(moment().month() - 1)
                .startOf('month'),
              moment()
                .month(moment().month() - 1)
                .endOf('month')
            ]
          }"
          style="width: 260px;margin-left:8px"
          v-model="dateContract"
          @change="selectedDate"
          :placeholder="['开始时间', '结束时间']"
        />
      </div>
      <div>
        <label>上级项目：</label>
        <a-select
          showSearch
          :filterOption="filterOption"
          v-model="selectedOneValContract"
          @change="selectedOneContract"
          placeholder="请选择项目"
          style="width: 160px; margin-right: 10px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListOneContract"
            :key="i"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <a-select
          @change="selectedTwoContract"
          v-model="selectedTwoValContract"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择项目"
          style="width: 160px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListTwoContract"
            :key="i"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </div>
      <div>
        <label><i>*</i>项目：</label>
        <a-select
          :maxTagCount="20"
          mode="multiple"
          style="width: 70%; margin-right: 10px"
          v-model="projectListContract"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择关联项目"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListThreeContract"
            :key="i"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox :checked="checkedContract" @change="selectedAllContract"
            >全选</a-checkbox
          >
        </span>
      </div>
      <div>
        <label><i>*</i>状态类型：</label>
        <a-radio-group v-model="contractType">
          <a-radio :value="0">
            全部
          </a-radio>
          <a-radio :value="1">
            入职合同
          </a-radio>
          <a-radio :value="2">
            离职合同
          </a-radio>
        </a-radio-group>
      </div>
      <div>
        <label><i>*</i>工作类型：</label>
        <a-radio-group v-model="work_contract_type">
          <a-radio :value="0">
            全部
          </a-radio>
          <a-radio :value="1">
            长期工合同
          </a-radio>
          <a-radio :value="2">
            临时工合同
          </a-radio>
        </a-radio-group>
      </div>
      <div>
        <label><i>*</i>合同：</label>
        <a-select
          mode="multiple"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择合同"
          style="width: 300px;margin-right: 10px"
          v-model="sign_agreement_ids"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in contractList"
            :key="i"
            >{{ item.agreement_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox
            :checked="checkedContractList"
            @change="selectedAllContractList"
            >全选</a-checkbox
          >
        </span>
      </div>
      <div v-show="sign_agreement_ids == ''">
        <label><i>*</i>员工：</label>
        <span>暂无合同可下载</span>
      </div>
      <div v-show="sign_agreement_ids != ''">
        <label><i>*</i>员工：</label>
        <a-select
          :maxTagCount="30"
          mode="multiple"
          style="width: 70%; margin-right: 10px"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择员工"
          v-model="workerIdsContract"
        >
          <a-select-option
            :value="item.user_id"
            v-for="(item, i) in workerListContract"
            :key="i"
            >{{ item.user_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox
            :checked="checkedContractWorker"
            @change="selectedAllContractWorker"
            >全选</a-checkbox
          >
        </span>
      </div>
      <div class="submitStyle">
        <a-button @click="onResetContract">重置</a-button>
        <a-button type="primary" @click="downloadContract">下载</a-button>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      upTxt: "下载",
      businessList: [],
      project_id: [],
      searchDate: [],
      project_ids: [],
      upTxtZip: "下载",
      checked: false,
      project_list: [],
      selectedOneValContract: "",
      selectedTwoValContract: "",
      projectListContract: [],
      proListOneContract: [],
      proListTwoContract: [],
      proListThreeContract: [],
      checkedContract: false,
      contractList: [],
      workerListContract: [],
      checkedContractWorker: false,
      checkedContractList: false,
      workerIdsContract: [],
      sign_agreement_ids: [],
      dateContract: null,
      start_date: "",
      end_date: "",
      on_job: 0,
      type: "",
      moment,
      work_contract_type: 0,
      contractType: 0
    };
  },
  mounted() {
    this.getBusiness(); //获取项目列表
    this.getProOne(); //一级项目
    this.getWorker(); //
  },
  watch: {
    contractType() {
      this.checkedContractWorker = false;
      this.checkedContractList = false;
      this.getContract(); //获取合同
    },
    work_contract_type() {
      this.checkedContractWorker = false;
      this.checkedContractList = false;
      this.getContract(); //获取合同
    },
    on_job() {
      this.checkedContractWorker = false;
      this.getWorker();
    },
    projectListContract() {
      this.checkedContractWorker = false;
      this.getWorker();
      this.getContract(); //获取合同
    },
    sign_agreement_ids() {
      this.getWorker();
    }
  },
  methods: {
    selectedDate(dates, dateStrings) {
      // console.log(dateStrings);
      this.start_date = dateStrings[0];
      this.end_date = dateStrings[1];
      this.checkedContractWorker = false;
      this.getWorker();
    },
    selectedAllContractList(e) {
      this.checkedContractWorker = e.target.checked;
      if (e.target.checked) {
        this.contractList.forEach(element => {
          if (this.sign_agreement_ids.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.sign_agreement_ids.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.sign_agreement_ids = [];
      }
    },
    selectedAllContractWorker(e) {
      this.checkedContractWorker = e.target.checked;
      if (e.target.checked) {
        this.workerListContract.forEach(element => {
          if (this.workerIdsContract.indexOf(element.user_id) == -1) {
            // console.log(element.id)
            this.workerIdsContract.push(element.user_id);
          }
          // console.log(element)
        });
      } else {
        this.workerIdsContract = [];
      }
    },
    getWorker() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/getUserByProjectAndAgreementThree";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_ids: JSON.stringify(this.projectListContract),
        sign_agreement_ids: JSON.stringify(this.sign_agreement_ids),
        start_date: this.start_date,
        end_date: this.end_date,
        on_job: this.on_job
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          this.workerIdsContract = [];
          this.workerListContract = res.data.data;
        }
      });
    },
    getContract() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "Sign/getList";
      axios
        .post(url, {
          per_page: 100000,
          work_contract_type: this.work_contract_type,
          type: this.contractType,
          project_ids:
            this.projectListContract.length == 0
              ? ""
              : JSON.stringify(this.projectListContract),
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.sign_agreement_ids = [];
            this.contractList = res.data.data.data;
            // console.log(this.contractList);
          }
        });
    },
    selectedOneContract(id) {
      this.checkedContract = false;
      this.selectedTwoValContract = "";
      this.getProID(id, 1); //获取下级项目
      this.getThreePro(id);
    },
    selectedTwoContract(id) {
      this.checkedContract = false;
      this.getProID(id, 2); //获取下级项目
    },
    selectedAllContract(e) {
      this.checkedContract = e.target.checked;
      if (this.selectedOneValContract == "") {
        this.projectListContract = [];
      }
      if (e.target.checked) {
        this.proListThreeContract.forEach(element => {
          if (this.projectListContract.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.projectListContract.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.projectListContract = [];
      }
    },
    onResetContract() {
      this.on_job = 0;
      this.contractType = 0;
      this.work_contract_type = 0;
      this.dateContract = null;
      this.start_date = "";
      this.end_date = "";
      this.projectListContract = [];
      this.checkedContract = false;
      this.selectedOneValContract = "";
      this.selectedTwoValContract = "";
      this.proListOneContract = [];
      this.proListTwoContract = [];
      this.proListThreeContract = [];
      this.workerIdsContract = [];
      this.checkedContractWorker = false;
      this.sign_agreement_ids = [];
      this.getProOne(); //一级项目
      this.getWorker();
      this.getBusiness(); //获取项目列表
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "contract/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOneContract = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwoContract = res.data.data;
            } else if (level == 2) {
              this.proListThreeContract = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getThreePro(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectTop";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThreeContract = res.data.data;

            // console.log(this.proListThree);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getBusiness() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListThreeData";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.proListThreeContract = res.data.data;
        }
      });
    },
    downloadContract() {
      let _this = this;
      if (this.sign_agreement_ids != "" && this.workerIdsContract != "") {
        this.$confirm({
          title: "是否确定下载员工合同?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upFollowContract();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("标记*为必填项");
      }
    },
    upFollowContract() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/downloadAgreement?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&sign_agreement_ids=" +
        JSON.stringify(this.sign_agreement_ids) +
        "&user_ids=" +
        JSON.stringify(this.workerIdsContract) +
        "&project_ids=" +
        JSON.stringify(this.projectListContract);
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  > section {
    padding: 40px 4% 30px;
    > div {
      margin: 10px 2% 20px;
      > label {
        display: inline-block;
        margin-right: 10px;
        i {
          display: inline-block;
          margin-right: 4px;
          font-style: normal;
          color: red;
        }
      }
    }
    h2 {
      font-size: 14px;
      font-weight: normal;
      margin-top: 20px;
      a {
        font-size: 14px;
        display: inline-block;
        color: #999;
      }
    }
    input {
      margin: 20px 30px;
    }
    .submitStyle {
      margin: 20px 0 0 80px;
      button {
        margin-left: 10px;
        display: inline-block;
      }
    }
  }
}
</style>
